import React, { ReactNode } from 'react';

import { Alert as AntdAlert } from 'antd';

import { InformationBannerProps } from './types';

import './index.less';

function InformationBanner({
  message,
  description,
  closable,
  onClose,
  alertType,
}: InformationBannerProps<ReactNode>): React.ReactElement {
  return (
    <AntdAlert
      message={message}
      description={description}
      type={alertType}
      showIcon
      closable={closable ?? false}
      onClose={onClose}
    />
  );
}

export default InformationBanner;
